import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellEditorRendererAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellEditorRendererParams, ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { ContractApiService } from 'src/app/core/api/contract-api.service';
import { SowApiService } from 'src/app/core/api/sow-api.service';

@Component({
  selector: 'app-actions',
  standalone: true,
  imports: [],
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss'
})
export class ActionsComponent implements ICellRendererAngularComp {
   private params: ICellRendererParams;

   constructor(
        private contractApiService: ContractApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService

    ) {}

  agInit(params: ICellRendererParams): void {
   this.params = params
  }



  refresh(params: ICellRendererParams): boolean {
    return false;
  }

onDeleteRow(): void {
    const rowData = this.params.node.data;

    this.contractApiService.deleteContractComment(rowData.id).subscribe({
        next: () => {
            this.params.api.applyTransaction({ remove: [rowData] });
            const message = this.translateService.instant("contractComment.form.delete")
            this.toastrService.success(message)
            this.params.api.refreshCells()
        },
       error:  () => {
             const message = this.translateService.instant("contractComment.form.deleteError")
             this.toastrService.error(message)
        }
    });
}

}
